import { Injectable } from '@angular/core';
import { IResponse } from "@bt/shared";
import { ApiService } from "./api.service";

@Injectable()
export class UploadService {

  public isNeedShowMap:boolean;
  constructor(private api: ApiService) {
    this.isNeedShowMap=false;
   }

  public uriBuilder(): string {
    return "api/upload";
  }

  public uploadFile(formdata:any,foldername : string):Promise<IResponse<number>>{
    return this.api.upload<number>(this.uriBuilder()+'/file/'+foldername, formdata).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/upload.service.ts